export default __webpack_public_path__ + "static/media/github.1093af60.png";